// Bump this together with convex/cloudSaveProtocol.ts whenever a server-side
// save safety invariant requires already-open clients to reload.
export const CLOUD_SAVE_PROTOCOL_VERSION = 4;
